var module = 'main', name = 'main/assets/svg/spinner.svg', content = "<?xml version=\"1.0\" encoding=\"utf-8\"?> <svg version=\"1.1\" id=\"icones\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 32 32\" enable-background=\"new 0 0 32 32\" xml:space=\"preserve\"><g><path d=\"M3.29,6.29L0.03,3.02l11.27-2.18L9.24,12.26l-3.4-3.41c-1.48,2.1-2.29,4.53-2.29,7.12c0,6.88,5.59,12.48,12.45,12.48V32\r\n\t\tC7.18,32,0,24.81,0,15.97C0,12.48,1.17,9.07,3.29,6.29z\"/><path d=\"M26.16,23.15c1.48-2.1,2.29-4.53,2.29-7.12c0-6.88-5.59-12.48-12.45-12.48V0c8.82,0,16,7.19,16,16.03\r\n\t\tc0,3.49-1.17,6.9-3.29,9.68l3.26,3.27l-11.26,2.18l2.05-11.42L26.16,23.15z\"/></g></svg>";
angular.module(module).run(['$templateCache', function($templateCache) {
  $templateCache.put(name, content);
}]);
module.exports = name;


//////////////////
// WEBPACK FOOTER
// ./main/assets/svg/spinner.svg
// module id = 1316
// module chunks = 0